import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Navbar from "./components/navbar/Navbar";
import { ThemeProvider } from "next-themes";
import FlowSelectionPage from "./pages/FlowSelectionPage";
import PostAnalysis from "./pages/PostAnalysis";
import { NavbarVisibilityProvider } from "./context/NavbarVisibilityContext";
import HealthCheck from "./pages/HealthCheck";
import { AuthProvider, ProtectedRoute } from "./hooks/authentication/useAuth";
import { PermissionProtectedRoute, UnauthorizedPage } from "./hooks/authentication/PermissionProtectedRoute";
import { PERMISSIONS } from "./hooks/authentication/usePermissions";
import LoginPage from "./components/auth/LoginPage";
import LaunchCampaign from "./pages/LaunchCampaign";
import BusinessAdminDashboard from "./pages/BusinessAdminDashboard";
import CampaignDetailView from "./pages/CampaignDetailView";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import { Toaster } from "@/components/ui/toaster";

function App() {

  return (
    <Router>
      <AuthProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="abinbev"
          enableSystem
          themes={["light", "dark", "abinbev"]}
        >
          <NavbarVisibilityProvider>
            <Navbar />
            <Routes>
              <Route path="/health-check-frontend" element={<HealthCheck />} />
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />
              
              <Route
                path="/flows/:flowId"
                element={
                  <ProtectedRoute>
                    <FlowSelectionPage />
                  </ProtectedRoute>
                }
              />
              
              <Route
                path="/post-analysis"
                element={
                  <PermissionProtectedRoute 
                    anyPermission={[PERMISSIONS.VIEW_POST_ANALYSIS, PERMISSIONS.VIEW_ADVANCED_POST_ANALYSIS]}
                    redirectTo="/unauthorized"
                  >
                    <PostAnalysis />
                  </PermissionProtectedRoute>
                }
              />
              
              <Route
                path="/launch-campaign"
                element={
                  <PermissionProtectedRoute 
                    requiredPermission={PERMISSIONS.LAUNCH_CAMPAIGN}
                    redirectTo="/unauthorized"
                  >
                    <LaunchCampaign />
                  </PermissionProtectedRoute>
                }
              />
              
              <Route
                path="/business-dashboard"
                element={
                  <PermissionProtectedRoute 
                    requiredPermission={PERMISSIONS.VIEW_CAMPAIGN_MANAGEMENT_DASHBOARD}
                    redirectTo="/unauthorized"
                  >
                    <BusinessAdminDashboard />
                  </PermissionProtectedRoute>
                }
              />
              
              
              <Route
                path="/admin-dashboard"
                element={
                  <PermissionProtectedRoute 
                    requiredPermission={PERMISSIONS.MANAGE_USERS}
                    redirectTo="/unauthorized"
                  >
                    <SuperAdminDashboard />
                  </PermissionProtectedRoute>
                }
              />
              
              <Route
                path="/business-admin/campaign/:campaignId"
                element={
                  <PermissionProtectedRoute 
                    requiredPermission={PERMISSIONS.VIEW_CAMPAIGN_MANAGEMENT_DASHBOARD}
                    redirectTo="/unauthorized"
                  >
                    <CampaignDetailView />
                  </PermissionProtectedRoute>
                }
              />
              
            </Routes>
          </NavbarVisibilityProvider>
          <Toaster />
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
